import { useFlags } from 'launchdarkly-react-client-sdk'
import { Navigate } from 'react-router-dom'
import {
  ROUTE_FEATURE_FLAGS,
  MAIN_NAV_TABS,
} from '@/constants/featureFlagRoutes'
import LoadingCard from './LoadingCard'

export default function DynamicRedirect() {
  const flags = useFlags()

  // Check if LaunchDarkly is still loading flags
  const isLoading = flags === undefined || Object.keys(flags).length === 0

  if (isLoading) {
    return <LoadingCard />
  }

  // Find the first available navigation tab based on feature flags
  const getFirstAvailableTab = () => {
    for (const tabPath of MAIN_NAV_TABS) {
      const routeFlag =
        ROUTE_FEATURE_FLAGS[tabPath as keyof typeof ROUTE_FEATURE_FLAGS]
      const isFlagEnabled = routeFlag === undefined ? true : flags[routeFlag]

      if (isFlagEnabled) {
        // Remove the /* from the path for navigation
        return tabPath.replace(/\/\*$/, '')
      }
    }

    // Fallback to unauthorized if no tabs are available
    return '/unauthorized'
  }

  const redirectPath = getFirstAvailableTab()

  return <Navigate to={redirectPath} replace />
}
